import { render } from "./SepticaDemo.vue?vue&type=template&id=ade1917a&scoped=true"
import script from "./SepticaDemo.vue?vue&type=script&lang=js"
export * from "./SepticaDemo.vue?vue&type=script&lang=js"

import "./SepticaDemo.vue?vue&type=style&index=0&id=ade1917a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade1917a"]])

export default __exports__